import { ChargeType, ChargePrefix } from '../enums';

// eslint-disable-next-line import/prefer-default-export
export const CHARGE_TYPE_BY_PREFIX = {
  [ChargeType.FlatRate]: ChargePrefix.Service,
  [ChargeType.Service]: ChargePrefix.Service,
  [ChargeType.Hourly]: ChargePrefix.Hr,
  [ChargeType.Daily]: ChargePrefix.Day,
  [ChargeType.Monthly]: ChargePrefix.Month,
  [ChargeType.Sqft]: ChargePrefix.Sqft,
  [ChargeType.Sqm]: ChargePrefix.Sqm,
  [ChargeType.CF]: ChargePrefix.CubicFoot,
  [ChargeType.CY]: ChargePrefix.CubicYard,
  [ChargeType.Image]: ChargePrefix.Image,
  [ChargeType.Picture]: ChargePrefix.Image,
  [ChargeType.Room]: ChargePrefix.Room,
  [ChargeType.Floor]: ChargePrefix.Floor,
  [ChargeType.Item]: ChargePrefix.Item,
  [ChargeType.Page]: ChargePrefix.Page,
  [ChargeType.Acre]: ChargePrefix.Acre,
  [ChargeType.Foot]: ChargePrefix.Foot,
  [ChargeType.Meter]: ChargePrefix.Meter,
  [ChargeType.Visit]: ChargePrefix.Visit,
};
